export const siteInfo = {
  name: '樱花动漫',
  tagline: '专注手机动漫的门户网站',
  description: '樱花动漫网提供全面的动漫大全资源，专为移动端优化，让您轻松浏览和观看各种动漫，随时随地满足您的娱乐需求。',
  url: 'https://www.yinghuaanime.com',
  established: '2018',
  email: 'contact@yinghuaanime.com',
  phone: '400-888-8888',
  address: '北京市朝阳区动漫产业园区A座',
  social: {
    weibo: 'https://weibo.com/yinghuaanime',
    bilibili: 'https://space.bilibili.com/yinghuaanime',
    wechat: '樱花动漫官方',
  },
};

export const categories = [
  { id: 'rexue', name: '热血', slug: 'rexue', icon: 'ri-fire-line', color: 'primary', description: '充满激情与战斗的热血动漫，点燃你的肾上腺素' },
  { id: 'lianai', name: '恋爱', slug: 'lianai', icon: 'ri-heart-line', color: 'primary', description: '甜蜜浪漫的恋爱动漫，感受青春的心跳' },
  { id: 'gaoxiao', name: '搞笑', slug: 'gaoxiao', icon: 'ri-emotion-laugh-line', color: 'accent', description: '轻松搞笑的喜剧动漫，笑到停不下来' },
  { id: 'qihuan', name: '奇幻', slug: 'qihuan', icon: 'ri-magic-line', color: 'secondary', description: '天马行空的奇幻动漫，开启异世界冒险' },
  { id: 'kehuan', name: '科幻', slug: 'kehuan', icon: 'ri-rocket-line', color: 'secondary', description: '未来科技与想象力的科幻动漫盛宴' },
  { id: 'xuanyi', name: '悬疑', slug: 'xuanyi', icon: 'ri-search-eye-line', color: 'primary', description: '扣人心弦的悬疑推理动漫，烧脑又过瘾' },
  { id: 'zhiyu', name: '治愈', slug: 'zhiyu', icon: 'ri-plant-line', color: 'secondary', description: '温暖人心的治愈系动漫，抚慰你的心灵' },
  { id: 'jizhan', name: '激战', slug: 'jizhan', icon: 'ri-sword-line', color: 'accent', description: '精彩绝伦的战斗场面，酣畅淋漓的对决' },
];

export interface AnimeArticle {
  id: string;
  title: string;
  slug: string;
  category: string;
  categoryName: string;
  coverImage: string;
  rating: number;
  episodes: string;
  status: string;
  year: number;
  author: string;
  description: string;
  content: string;
  tags: string[];
  featured: boolean;
  isNew: boolean;
  views: number;
  publishDate: string;
  updateDate: string;
}

export const animeArticles: AnimeArticle[] = [
  {
    id: '1',
    title: '进击的巨人 最终季',
    slug: 'attack-on-titan-final',
    category: 'rexue',
    categoryName: '热血',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20determined%20warrior%20with%20swords%20facing%20giant%20titans%20in%20a%20dramatic%20post%20apocalyptic%20setting%20with%20dark%20sky%20and%20ruins%20cinematic%20lighting%20epic%20composition%20high%20contrast%20poster%20art&width=600&height=840&seq=anime-cover-01&orientation=portrait',
    rating: 9.8,
    episodes: '共28话',
    status: '已完结',
    year: 2023,
    author: '谏山创',
    description: '历经十年，《进击的巨人》迎来了震撼人心的最终章。艾伦·耶格尔启动地鸣，世界陷入了前所未有的危机之中，曾经的战友们将如何面对这毁灭性的力量？最终季为这部传奇作品画上了史诗般的句号。',
    content: `<h2>作品简介</h2><p>《进击的巨人》是日本漫画家谏山创创作的黑暗奇幻少年漫画作品，故事建立在人类与巨人的冲突之上。人类居住在由巨大墙壁包围的城市中，以抵御会吞食人类的巨人。故事围绕着主角艾伦·耶格尔和他的朋友们的成长与战斗展开。</p><h2>最终季看点</h2><p>最终季中，艾伦·耶格尔启动了「地鸣」，数以万计的超大型巨人踏平世界。曾经并肩作战的调查兵团成员们——三笠、阿尔敏、让、康尼等人，必须在友情与正义之间做出痛苦抉择。</p><p>马莱战士莱纳、皮克等人与帕拉迪岛的战士们形成了不可思议的联盟，共同对抗这场毁灭性的灾难。这场战斗不仅仅是武力的较量，更是理念与信念的碰撞。</p><h2>角色成长</h2><p>从最初那个渴望自由、誓言驱逐所有巨人的少年，到最终成为毁灭世界的「恶魔」，艾伦的角色弧线堪称动漫史上最具冲击力的转变之一。三笠的深情守护、阿尔敏的理想主义、利威尔的坚毅不屈，每个角色都在最终季中得到了完整的诠释。</p>`,
    tags: ['进击的巨人', '谏山创', 'MAPPA', '热血', '战斗', '最终季'],
    featured: true,
    isNew: false,
    views: 2560000,
    publishDate: '2023-03-04',
    updateDate: '2023-11-05',
  },
  {
    id: '2',
    title: '鬼灭之刃 柱训练篇',
    slug: 'demon-slayer-hashira-training',
    category: 'rexue',
    categoryName: '热血',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20young%20swordsman%20with%20green%20checkered%20haori%20holding%20a%20katana%20with%20water%20breathing%20effect%20intense%20expression%20cinematic%20lighting%20dark%20background%20with%20cherry%20blossom%20petals%20floating&width=600&height=840&seq=anime-cover-02&orientation=portrait',
    rating: 9.5,
    episodes: '共8话',
    status: '已完结',
    year: 2024,
    author: '吾峠呼世晴',
    description: '为迎接最终决战，炭治郎与同伴们在柱的指导下进行严酷训练。每位柱都以独特的方式磨练着年轻的剑士们，为对抗无惨做好万全准备。',
    content: `<h2>作品简介</h2><p>《鬼灭之刃》是由吾峠呼世晴创作的日本漫画作品，讲述了少年灶门炭治郎为了拯救变成鬼的妹妹祢豆子，加入鬼杀队讨伐鬼王无惨的故事。</p><h2>柱训练篇看点</h2><p>柱训练篇是连接锻刀村篇与最终决战的关键篇章。在无限城决战前夕，九位柱各自展开了对新晋剑士们的强化训练。炭治郎、善逸、伊之助等人将在音柱宇髄天元、恋柱甘露寺蜜璃、蛇柱伊黑小芭内等柱的指导下，突破自身极限。</p><h2>动画制作</h2><p>ufotable继续以超高水准呈现出鬼灭之刃的精彩战斗场面。流畅的动作设计、华丽的水之呼吸特效、以及细腻的角色表情刻画，让每一帧画面都堪称艺术品。柱训练篇虽然战斗场面相对较少，但人物互动和情感铺垫达到了新的高度。</p>`,
    tags: ['鬼灭之刃', 'ufotable', '热血', '战斗', '柱训练篇'],
    featured: true,
    isNew: true,
    views: 3120000,
    publishDate: '2024-05-12',
    updateDate: '2024-06-30',
  },
  {
    id: '3',
    title: '间谍过家家 第二季',
    slug: 'spy-x-family-season2',
    category: 'gaoxiao',
    categoryName: '搞笑',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20family%20of%20three%20a%20man%20in%20a%20suit%20a%20woman%20with%20red%20hair%20and%20a%20little%20girl%20with%20pink%20hair%20telepathic%20powers%20cute%20and%20funny%20atmosphere%20warm%20colors%20pastel%20background%20with%20peanuts&width=600&height=840&seq=anime-cover-03&orientation=portrait',
    rating: 9.3,
    episodes: '共25话',
    status: '已完结',
    year: 2023,
    author: '远藤达哉',
    description: '间谍父亲、杀手母亲、超能力女儿，这个临时组建的家庭继续上演温馨搞笑又惊险刺激的日常故事。安妮亚的校园生活更是笑料百出！',
    content: `<h2>作品简介</h2><p>《间谍过家家》是远藤达哉创作的漫画作品，讲述了西国顶级间谍「黄昏」为了执行任务，临时组建了一个家庭——杀手妻子约尔和会读心术的女儿安妮亚。三人彼此隐藏着真实身份，却在这段虚假的家庭关系中找到了真正的温暖。</p><h2>第二季看点</h2><p>第二季延续了第一季温馨搞笑的风格，同时加入了更多惊险刺激的间谍行动。洛伊德为了维护世界和平而奔波，约尔作为「睡美人」执行暗杀任务，而安妮亚则在伊甸学院努力争取获得「星章」。</p><p>邦德狗的加入让这个家庭更加热闹，这只能预知未来的大型犬为故事增添了无数惊喜和感动。游轮篇更是将剧情推向了高潮，展现了约尔作为杀手的惊人实力。</p>`,
    tags: ['间谍过家家', '远藤达哉', '搞笑', '温馨', 'WIT STUDIO'],
    featured: true,
    isNew: false,
    views: 1980000,
    publishDate: '2023-10-07',
    updateDate: '2023-12-23',
  },
  {
    id: '4',
    title: '葬送的芙莉莲',
    slug: 'frieren-beyond-journey-end',
    category: 'zhiyu',
    categoryName: '治愈',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20beautiful%20elf%20mage%20with%20long%20silver%20hair%20holding%20a%20staff%20walking%20through%20a%20peaceful%20meadow%20with%20flowers%20soft%20warm%20sunlight%20nostalgic%20atmosphere%20emotional%20and%20serene&width=600&height=840&seq=anime-cover-04&orientation=portrait',
    rating: 9.7,
    episodes: '共28话',
    status: '已完结',
    year: 2023,
    author: '山田钟人/阿部司',
    description: '勇者队伍打败魔王后，精灵魔法使芙莉莲开始了理解人类情感与时间意义的旅程。一部关于生命、记忆与告别的心灵之作。',
    content: `<h2>作品简介</h2><p>《葬送的芙莉莲》讲述了勇者辛美尔一行人在打倒魔王之后的故事。长生不老的精灵魔法使芙莉莲，在与人类同伴经历十年冒险后，亲眼目睹了同伴们的衰老与离去，开始踏上了理解人类情感的旅程。</p><h2>故事主题</h2><p>这是一部关于「理解」的作品。芙莉莲的旅程不是去打倒什么敌人，而是去理解那些已经逝去的同伴们曾经对她的感情，理解人类短暂生命中蕴藏的深刻情感。每一集都像一首温柔的诗，轻轻触碰观众心中最柔软的地方。</p><h2>动画品质</h2><p>MADHOUSE以电影级别的制作水准呈现了这部作品。精美细腻的背景美术、流畅自然的人物动作、恰到好处的配乐，每一个细节都展现出对原作的深刻理解与尊重。特别是那些关于时间流逝的蒙太奇画面，令人动容落泪。</p>`,
    tags: ['葬送的芙莉莲', '治愈', '奇幻', 'MADHOUSE', '情感'],
    featured: false,
    isNew: false,
    views: 1890000,
    publishDate: '2023-09-29',
    updateDate: '2024-03-22',
  },
  {
    id: '5',
    title: '咒术回战 第二季',
    slug: 'jujutsu-kaisen-season2',
    category: 'rexue',
    categoryName: '热血',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20powerful%20sorcerer%20with%20white%20hair%20and%20blindfold%20fighting%20with%20blue%20energy%20surrounded%20by%20cursed%20spirits%20dynamic%20action%20pose%20intense%20battle%20scene%20dark%20urban%20setting&width=600&height=840&seq=anime-cover-05&orientation=portrait',
    rating: 9.4,
    episodes: '共23话',
    status: '已完结',
    year: 2023,
    author: '芥见下下',
    description: '涩谷事变震撼来袭！五条悟与夏油杰的过去被揭开，虎杖悠仁面对前所未有的挑战。MAPPA倾力打造的现象级热血巨作第二季。',
    content: `<h2>作品简介</h2><p>《咒术回战》讲述了高中生虎杖悠仁吞下诅咒之王两面宿傩的手指后，加入东京都立咒术高等专门学校，与其他咒术师一同对抗诅咒的故事。</p><h2>第二季「涩谷事变」看点</h2><p>第二季分为「怀玉·玉折」和「涩谷事变」两个篇章。前半部分讲述了五条悟与夏油杰高中时期的故事，揭开了两人从挚友走向对立的悲壮过往。后半部分则是全作最震撼的「涩谷事变」篇章。</p><p>在万圣夜拥挤的涩谷街头，咒灵们发动了大规模袭击。五条悟被封印、虎杖失控、钉崎重伤……一系列令人窒息的展开让观众心跳加速。MAPPA的动画制作将这场惨烈的战斗推向了极致。</p>`,
    tags: ['咒术回战', 'MAPPA', '热血', '战斗', '涩谷事变'],
    featured: false,
    isNew: false,
    views: 2850000,
    publishDate: '2023-07-06',
    updateDate: '2023-12-28',
  },
  {
    id: '6',
    title: '我推的孩子',
    slug: 'oshi-no-ko',
    category: 'xuanyi',
    categoryName: '悬疑',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20beautiful%20idol%20girl%20with%20star%20eyes%20on%20stage%20under%20spotlight%20dramatic%20lighting%20mysterious%20atmosphere%20with%20microphone%20stand%20dark%20background%20with%20stars&width=600&height=840&seq=anime-cover-06&orientation=portrait',
    rating: 9.2,
    episodes: '共11话',
    status: '已完结',
    year: 2023,
    author: '赤坂明/横枪萌果',
    description: '当红偶像星野爱的双胞胎孩子带着前世记忆转生，在娱乐圈的华丽外表下，隐藏着不为人知的黑暗真相。一部令人震撼的娱乐圈悬疑大戏。',
    content: `<h2>作品简介</h2><p>《我推的孩子》是由《辉夜大小姐想让我告白》作者赤坂明担任原作、《人渣的本愿》作者横枪萌果负责作画的漫画作品。故事讲述了妇产科医生雨宫吾郎意外转生成为自己推的偶像星野爱的孩子——星野爱久爱海（阿库亚），与同一天转生的病人天童寺纱利奈（露比）成为了双胞胎兄妹。</p><h2>剧情亮点</h2><p>第一集以长达90分钟的特别篇形式播出，震撼了全球动漫观众。故事将偶像文化、娱乐圈黑暗面、悬疑推理和转生奇幻巧妙融合，创造出独一无二的观看体验。阿库亚为了寻找杀害母亲的真凶，踏入了复杂的演艺圈，而露比则朝着成为顶级偶像的梦想努力。</p><h2>主题探讨</h2><p>作品深刻探讨了偶像产业的真实面貌、社交媒体时代的网络暴力、以及娱乐圈中的谎言与真相。华丽的舞台背后，隐藏着无数不为人知的辛酸故事。</p>`,
    tags: ['我推的孩子', '悬疑', '偶像', '转生', '动工'],
    featured: false,
    isNew: false,
    views: 2210000,
    publishDate: '2023-04-12',
    updateDate: '2023-06-28',
  },
  {
    id: '7',
    title: '迷宫饭',
    slug: 'delicious-in-dungeon',
    category: 'qihuan',
    categoryName: '奇幻',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20group%20of%20adventurers%20cooking%20monsters%20in%20a%20fantasy%20dungeon%20delicious%20food%20steaming%20hot%20funny%20expressions%20warm%20lighting%20detailed%20food%20art&width=600&height=840&seq=anime-cover-07&orientation=portrait',
    rating: 9.1,
    episodes: '共24话',
    status: '已完结',
    year: 2024,
    author: '九井谅子',
    description: '在迷宫深处，冒险者们的终极挑战不是屠龙，而是如何把各种魔物烹饪成美味佳肴！一部让人垂涎欲滴的奇幻美食冒险。',
    content: `<h2>作品简介</h2><p>《迷宫饭》是九井谅子创作的漫画作品。故事讲述冒险者莱欧斯一行人在迷宫深处失去了妹妹法琳，为了在资金耗尽的情况下重返迷宫深处拯救妹妹，他们决定就地取材——将迷宫中的魔物烹饪成美食来解决温饱问题。</p><h2>独特魅力</h2><p>《迷宫饭》最吸引人的地方在于它巧妙地将奇幻冒险与美食烹饪结合在一起。每一话都会详细介绍某种魔物的生态习性，然后展示如何将其制作成令人垂涎的料理。从行走菇的奶油炖菜到宝箱怪的味噌汤，创意十足的菜谱令人拍案叫绝。</p><p>精良的动画制作由TRIGGER负责，画面细腻生动，魔物设计丰富多彩，料理场景更是让观众食欲大开。角色之间的互动温馨有趣，每个角色都有鲜明的个性和成长弧线。</p>`,
    tags: ['迷宫饭', '奇幻', '美食', '冒险', 'TRIGGER'],
    featured: false,
    isNew: true,
    views: 1450000,
    publishDate: '2024-01-04',
    updateDate: '2024-06-13',
  },
  {
    id: '8',
    title: '药屋少女的呢喃',
    slug: 'apothecary-diaries',
    category: 'xuanyi',
    categoryName: '悬疑',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20beautiful%20girl%20with%20freckles%20in%20ancient%20Chinese%20palace%20clothing%20holding%20herbs%20and%20medicine%20elegant%20and%20mysterious%20atmosphere%20traditional%20architecture%20background%20soft%20lighting&width=600&height=840&seq=anime-cover-08&orientation=portrait',
    rating: 9.3,
    episodes: '共24话',
    status: '已完结',
    year: 2023,
    author: '日向夏',
    description: '天才药师少女猫猫在宫廷后宫中，以过人的智慧破解一个个离奇案件。精美的宫廷画风、引人入胜的推理剧情，令人欲罢不能。',
    content: `<h2>作品简介</h2><p>《药屋少女的呢喃》讲述了在虚构的中世纪东方大国「茘」的后宫中，拥有丰富药学知识的少女猫猫，凭借敏锐的观察力和推理能力，巧妙解决后宫各种疑难杂症和离奇案件的故事。</p><h2>角色魅力</h2><p>猫猫是一个极具魅力的女主角——她聪明冷静，对毒药和药材有着近乎痴迷的兴趣，同时又带着纯真可爱的一面。她与美貌冷酷的宦官壬氏的互动充满了微妙的化学反应，两人之间若即若离的关系令人心动不已。</p><h2>艺术风格</h2><p>动画以极其精美细致的画风呈现了中国风宫廷的华丽与韵味。无论是服饰的花纹、建筑的雕饰，还是花草药材的细节，都展现出制作组对中国文化的深入研究与尊重。配乐融合了传统东方乐器与现代交响乐，营造出独特的视听体验。</p>`,
    tags: ['药屋少女的呢喃', '悬疑', '宫廷', '推理', '中国风'],
    featured: false,
    isNew: false,
    views: 1760000,
    publishDate: '2023-10-22',
    updateDate: '2024-03-24',
  },
  {
    id: '9',
    title: '我心里危险的东西',
    slug: 'dangers-in-my-heart',
    category: 'lianai',
    categoryName: '恋爱',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20shy%20boy%20and%20a%20beautiful%20tall%20girl%20in%20school%20uniform%20standing%20in%20a%20library%20blushing%20sweet%20romance%20atmosphere%20soft%20warm%20light%20through%20windows%20cherry%20blossom%20petals&width=600&height=840&seq=anime-cover-09&orientation=portrait',
    rating: 9.4,
    episodes: '共25话',
    status: '连载中',
    year: 2024,
    author: '樱井纪雄',
    description: '中二病少年市川京太郎遇到班上的人气美少女山田杏奈，两人的距离在图书馆的日常中悄然拉近。最纯粹甜蜜的校园恋爱物语。',
    content: `<h2>作品简介</h2><p>《我心里危险的东西》讲述了患有中二病的初中生市川京太郎，与班上的人气女生山田杏奈之间发生的纯真恋爱故事。市川原本幻想着杀死同学们，尤其是山田杏奈，但在图书馆的日常相处中，他逐渐发现山田并非表面上那样完美，而是一个可爱又有点笨拙的普通女孩。</p><h2>恋爱描写</h2><p>本作对青春期暧昧情感的刻画堪称教科书级别。市川和山田之间那些微妙的瞬间——不小心碰触到的手指、互相对视后的慌乱、为对方准备的小惊喜——每一个细节都让人心跳加速。作品完美捕捉了初恋时那种既甜蜜又不安的复杂心情。</p><h2>角色成长</h2><p>市川从一个阴暗孤僻的中二少年，逐渐学会敞开心扉与他人交流，这种成长弧线令人感动。而山田也不是传统意义上的完美女主角，她有自己的烦恼和不自信。两个人互相治愈、互相成长的恋爱故事，温暖了无数观众的心。</p>`,
    tags: ['我心里危险的东西', '恋爱', '校园', '青春', '治愈'],
    featured: false,
    isNew: true,
    views: 1320000,
    publishDate: '2024-01-07',
    updateDate: '2024-06-29',
  },
  {
    id: '10',
    title: '不死少女的谋杀',
    slug: 'undead-girl-murder-farce',
    category: 'xuanyi',
    categoryName: '悬疑',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20girl%20in%20a%20cage%20with%20only%20a%20head%20elegant%20gothic%20victorian%20style%20mysterious%20detective%20theme%20dark%20atmosphere%20with%20candlelight%20moonlight%20through%20window&width=600&height=840&seq=anime-cover-10&orientation=portrait',
    rating: 8.9,
    episodes: '共13话',
    status: '已完结',
    year: 2023,
    author: '青崎有吾',
    description: '只有头颅的不死少女与半人半鬼的保镖，在欧洲各地破解涉及怪物的离奇案件。哥特式悬疑推理与奇幻元素完美交融。',
    content: `<h2>作品简介</h2><p>《不死少女的谋杀》改编自青崎有吾的同名推理小说系列。故事发生在19世纪末的欧洲，讲述了一位被不明人士夺去身体、只剩头颅却永远不会死去的少女轮堂鸦夜，与被称为「鬼杀」的半人半鬼保镖真打津轻，一同在欧洲各地破解涉及怪物和超自然现象的离奇案件。</p><h2>推理特色</h2><p>作为推理小说改编的作品，《不死少女的谋杀》在推理逻辑上极为严谨。每个案件都经过精心设计，线索的铺设和推理过程令人信服。鸦夜以她超人般的推理能力，从蛛丝马迹中拼凑出真相，将凶手绳之以法。</p><h2>视听风格</h2><p>动画以独特的哥特式风格呈现，阴暗华丽的视觉效果与扣人心弦的推理剧情相得益彰。对话密集而富有智慧，是推理爱好者的视听盛宴。</p>`,
    tags: ['不死少女的谋杀', '悬疑', '推理', '哥特', '奇幻'],
    featured: false,
    isNew: false,
    views: 890000,
    publishDate: '2023-07-06',
    updateDate: '2023-09-28',
  },
  {
    id: '11',
    title: '跃动青春',
    slug: 'skip-and-loafer',
    category: 'zhiyu',
    categoryName: '治愈',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20cheerful%20girl%20jumping%20happily%20in%20school%20uniform%20surrounded%20by%20friends%20in%20a%20sunny%20school%20courtyard%20warm%20colors%20spring%20atmosphere%20cherry%20blossoms%20youthful%20energy&width=600&height=840&seq=anime-cover-11&orientation=portrait',
    rating: 9.2,
    episodes: '共12话',
    status: '已完结',
    year: 2023,
    author: '高松美咲',
    description: '乡下女孩岩仓美津未来到东京读高中，用她的真诚与乐观感染了身边的每一个人。一部温暖治愈的青春成长物语。',
    content: `<h2>作品简介</h2><p>《跃动青春》讲述了来自石川县乡下的少女岩仓美津未，以第一名的成绩考入东京的高偏差值高中，怀抱着完美人生规划来到大城市。然而，开学第一天她就在车站迷路，遇到了同校的帅气男生志摩聪介，两人的人生轨迹从此交织在一起。</p><h2>角色魅力</h2><p>美津未是一个天真直率、充满正能量的女孩。她虽然来自乡下，对东京的一切都感到新鲜，但她从不自卑，总是以真诚的态度面对每一个人和每一件事。她的纯真与善良像阳光一样温暖着周围的人，包括表面完美实则内心空虚的志摩。</p><h2>青春的真实</h2><p>《跃动青春》最动人的地方在于它对青春期情感的真实刻画。没有夸张的戏剧冲突，没有狗血的误会纠葛，只有一群高中生在成长过程中经历的那些微小而珍贵的瞬间——第一次交到朋友、第一次心动、第一次面对自己的不足。每一集都让人会心一笑，也让人热泪盈眶。</p>`,
    tags: ['跃动青春', '治愈', '校园', '青春', '成长'],
    featured: false,
    isNew: false,
    views: 1100000,
    publishDate: '2023-04-04',
    updateDate: '2023-06-20',
  },
  {
    id: '12',
    title: '物理魔法使马修',
    slug: 'mashle-magic-and-muscles',
    category: 'gaoxiao',
    categoryName: '搞笑',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20muscular%20young%20man%20with%20a%20deadpan%20expression%20wearing%20a%20wizard%20robe%20holding%20a%20cream%20puff%20in%20a%20magic%20school%20setting%20funny%20contrast%20comedy&width=600&height=840&seq=anime-cover-12&orientation=portrait',
    rating: 8.7,
    episodes: '共24话',
    status: '连载中',
    year: 2024,
    author: '甲本一',
    description: '在魔法至上的世界里，完全不会魔法的马修用纯粹的肌肉力量打破一切规则！一拳粉碎魔法，一脚踢飞魔杖的爆笑无厘头喜剧。',
    content: `<h2>作品简介</h2><p>《物理魔法使马修》设定在一个魔法决定一切的世界里。不会使用魔法的人会被清除，而主角马修·班地德就是一个天生没有任何魔法天赋的少年。但他拥有超越常人的肌肉力量！为了保护自己和养父的平静生活，马修决定用纯粹的物理力量——也就是肌肉——来挑战魔法世界的一切规则。</p><h2>搞笑风格</h2><p>本作的核心笑料来自于马修用蛮力对抗魔法的荒诞反差。当其他学生念咒语施魔法时，马修就直接一拳打过去。他称自己的肌肉力量为「肌肉魔法」，一本正经地胡扯的样子令人捧腹。同时，他对奶油泡芙的执着热爱也是一个贯穿全剧的幽默元素。</p><h2>动画制作</h2><p>A-1 Pictures以高水准的动作作画呈现出马修夸张的物理攻击——每一次出拳都充满了力量感和视觉冲击力。声优小林千晃对马修平淡语气的精彩演绎，也让这个面瘫肌肉男的角色魅力倍增。</p>`,
    tags: ['物理魔法使马修', '搞笑', '魔法', '战斗', 'A-1 Pictures'],
    featured: false,
    isNew: true,
    views: 1560000,
    publishDate: '2024-01-06',
    updateDate: '2024-06-22',
  },
  {
    id: '13',
    title: '夏日重现',
    slug: 'summer-time-rendering',
    category: 'xuanyi',
    categoryName: '悬疑',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20boy%20and%20girl%20on%20a%20small%20island%20during%20sunset%20mysterious%20shadowy%20figures%20looming%20time%20loop%20concept%20summer%20atmosphere%20suspenseful%20dramatic%20lighting&width=600&height=840&seq=anime-cover-13&orientation=portrait',
    rating: 9.0,
    episodes: '共25话',
    status: '已完结',
    year: 2022,
    author: '田中靖规',
    description: '回到故乡小岛的少年发现青梅竹马已经死亡，而岛上隐藏着关于「影子」的神秘力量。一场围绕时间循环的悬疑推理大戏。',
    content: `<h2>作品简介</h2><p>《夏日重现》是田中靖规创作的悬疑漫画。故事讲述了网代慎平回到阔别两年的故乡日都岛参加青梅竹马小舟潮的葬礼，却发现潮的死亡并非意外。岛上流传着关于「影子」的古老传说——影子会杀死本体并取而代之。就在慎平调查真相时，他也被影子杀死，却发现自己回到了两天前……</p><h2>推理元素</h2><p>《夏日重现》的推理结构极为精巧。慎平每次死亡后都会带着记忆回到过去，利用之前获得的线索来改变未来。这种「时间循环+悬疑推理」的设定让观众可以不间断地跟随主角一步步揭开谜底，每一次循环都带来新的信息和意想不到的转折。</p><h2>动画亮点</h2><p>OLM制作的动画在视觉呈现上极为出色，日都岛的夏日风光与阴暗诡异的影子形成了鲜明对比。紧张的追逐战、精彩的智斗对决，以及令人窒息的悬疑氛围，让每一集都充满了紧迫感。</p>`,
    tags: ['夏日重现', '悬疑', '时间循环', '推理', 'OLM'],
    featured: false,
    isNew: false,
    views: 1670000,
    publishDate: '2022-04-14',
    updateDate: '2022-09-29',
  },
  {
    id: '14',
    title: '天国大魔境',
    slug: 'heavenly-delusion',
    category: 'kehuan',
    categoryName: '科幻',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20boy%20and%20girl%20traveling%20through%20a%20post%20apocalyptic%20Japan%20ruined%20cityscape%20overgrown%20with%20nature%20sci%20fi%20elements%20mysterious%20atmosphere%20dramatic%20sky&width=600&height=840&seq=anime-cover-14&orientation=portrait',
    rating: 9.1,
    episodes: '共13话',
    status: '已完结',
    year: 2023,
    author: '石黑正数',
    description: '在文明崩溃后的日本，两名少年少女在末世中寻找传说中的「天国」。一条线是末日废土的冒险，另一条线是神秘设施中的孩子们——两条故事线最终如何交汇？',
    content: `<h2>作品简介</h2><p>《天国大魔境》改编自石黑正数的漫画。故事分为两条并行的时间线：一条是末日废土中，少年斩子和少女真流在毁灭的日本寻找被称为「天国」的地方，真流拥有触碰即可杀死食人怪物的特殊能力；另一条则是某个被高墙包围的设施中，一群孩子过着看似无忧无虑的生活，但这里隐藏着巨大的秘密。</p><h2>叙事结构</h2><p>《天国大魔境》最精妙的地方在于其双线叙事结构。观众在观看时会不断思考两条故事线之间的关系——它们是否是同一个时间线？设施里的孩子们与废土上的怪物有什么关联？随着剧情推进，两条线索逐渐收束，最终的真相令人震撼又心碎。</p><h2>制作水准</h2><p>Production I.G带来的动画制作质量极高。末世日本的荒凉美感、设施内部的洁净诡异、以及角色细腻的情感表现，都通过精美的画面完美呈现。</p>`,
    tags: ['天国大魔境', '科幻', '末世', '悬疑', 'Production I.G'],
    featured: false,
    isNew: false,
    views: 1230000,
    publishDate: '2023-04-01',
    updateDate: '2023-06-24',
  },
  {
    id: '15',
    title: '孤独摇滚',
    slug: 'bocchi-the-rock',
    category: 'zhiyu',
    categoryName: '治愈',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20shy%20pink%20haired%20girl%20holding%20a%20guitar%20nervously%20in%20a%20live%20house%20setting%20colorful%20music%20theme%20cute%20and%20comedy%20atmosphere%20warm%20stage%20lights&width=600&height=840&seq=anime-cover-15&orientation=portrait',
    rating: 9.3,
    episodes: '共12话',
    status: '已完结',
    year: 2022,
    author: '滨路晶',
    description: '极度社恐的少女后藤一里偶然加入乐队，从此开启了充满欢笑与泪水的摇滚之路。本年度最治愈的音乐题材动画。',
    content: `<h2>作品简介</h2><p>《孤独摇滚》讲述了极度社交恐惧症的高中少女后藤一里（绰号「小孤独」），怀抱着成为摇滚巨星的梦想，每天独自练习吉他六小时，并将演奏视频上传到网络。某天，她被偶然遇到的鼓手伊地知虹夏拉入了名为「结束乐队」的新生乐队，从此开始了改变人生的音乐旅程。</p><h2>角色魅力</h2><p>后藤一里是近年来动漫中最令人共鸣的角色之一。她面对社交场合时的各种夸张反应——融化、爆炸、变成灰烬——既搞笑又真实。但当她拿起吉他时，整个人都散发出耀眼的光芒，这种反差是她最大的魅力所在。乐队成员们各具特色：温柔可靠的虹夏、冷酷但可爱的凉、元气满满的喜多，四个女孩之间的化学反应令人着迷。</p><h2>动画创新</h2><p>CloverWorks在视觉表现上的创意令人惊艳——用定格动画、粘土动画、实拍合成等多种非传统手法来表现小孤独的内心世界，每一集都充满了惊喜。而live演出场景更是以电影级别的制作呈现，让人仿佛身临其境。</p>`,
    tags: ['孤独摇滚', '音乐', '治愈', '喜剧', 'CloverWorks'],
    featured: false,
    isNew: false,
    views: 2080000,
    publishDate: '2022-10-09',
    updateDate: '2022-12-25',
  },
];

export const faqs = [
  {
    question: '樱花动漫网上的动漫资源需要付费吗？',
    answer: '樱花动漫网提供的大部分动漫资源均可免费在线浏览。我们致力于为动漫爱好者打造一个便捷、免费的手机动漫门户，让每一位动漫迷都能随时随地享受精彩的动漫内容。部分独家授权内容可能会有会员专属服务，敬请期待。',
  },
  {
    question: '樱花动漫网支持手机端观看吗？',
    answer: '是的！樱花动漫网作为专注手机动漫的门户网站，从设计之初就专为移动端优化。无论您使用的是iOS还是Android设备，都可以通过手机浏览器流畅访问我们的网站，享受高清流畅的动漫观看体验。我们的响应式设计确保在不同屏幕尺寸上都能获得最佳视觉效果。',
  },
  {
    question: '网站上的动漫更新频率是怎样的？',
    answer: '我们的编辑团队每日更新动漫资源，确保您可以第一时间观看到最新的动漫番剧。热门新番通常在播出后24小时内完成更新，我们的动漫大全涵盖了从经典老番到最新热播的全部内容，让您不错过任何一部精彩动漫。',
  },
  {
    question: '如何找到自己想看的动漫？',
    answer: '樱花动漫网提供了多种便捷的查找方式：您可以通过顶部的分类导航按照热血、恋爱、搞笑、奇幻等类型浏览动漫；也可以使用搜索功能直接查找动漫名称；首页的热门推荐和最新更新板块也能帮助您发现精彩内容。我们还为每部动漫设置了详细的标签系统，点击标签即可发现相关作品。',
  },
  {
    question: '樱花动漫网支持离线下载吗？',
    answer: '目前樱花动漫网的动漫大全资源以在线观看为主。我们正在积极推进离线缓存功能的开发，预计将在后续版本中推出。届时，您将可以在有网络时提前缓存喜爱的动漫内容，在离线状态下也能畅享动漫乐趣。请持续关注我们的更新公告。',
  },
];

export const testimonials = [
  {
    id: 1,
    name: '动漫迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20young%20Chinese%20man%20with%20glasses%20friendly%20smile%20clean%20simple%20background%20warm%20lighting&width=120&height=120&seq=avatar-testimonial-01&orientation=squarish',
    rating: 5,
    content: '樱花动漫网真的是手机上看动漫的最佳选择！界面简洁流畅，分类清晰，更新速度快，我每天都在上面追番。强烈推荐给所有动漫爱好者！',
    date: '2026-07-15',
  },
  {
    id: 2,
    name: '二次元少女',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20young%20Chinese%20girl%20with%20long%20hair%20cute%20expression%20clean%20simple%20background%20soft%20lighting&width=120&height=120&seq=avatar-testimonial-02&orientation=squarish',
    rating: 5,
    content: '作为一个资深动漫迷，樱花动漫网的动漫大全真的太全面了！从经典老番到最新热播，应有尽有。手机浏览体验极佳，通勤路上看动漫简直不要太方便~',
    date: '2026-06-28',
  },
  {
    id: 3,
    name: '追番达人阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20young%20Chinese%20man%20with%20cool%20expression%20wearing%20headphones%20clean%20simple%20background%20neutral%20lighting&width=120&height=120&seq=avatar-testimonial-03&orientation=squarish',
    rating: 5,
    content: '用了樱花动漫网之后就没再用过其他动漫网站了。这里的分类导航特别清晰，热血、恋爱、悬疑、治愈各种类型都有，每部动漫的详情介绍也很用心。',
    date: '2026-07-03',
  },
];